export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
export const PLAY_MEDIA = 'PLAY_MEDIA' // 播放资源


// WEBPACK FOOTER //
// ./src/store/mutation-types.js